/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_WeeklyInputs */

const en_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly`)
};

const es_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanal`)
};

const fr_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À la semaine`)
};

const de_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wöchentlich`)
};

const ja_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1週間あたり`)
};

const zh_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按周`)
};

const ar_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسبوعياً`)
};

const id_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mingguan`)
};

const it_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Settimana`)
};

const ru_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Еженедельно`)
};

const pt_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanal`)
};

const ko_val_weekly = /** @type {(inputs: Val_WeeklyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주당`)
};

/**
* | output |
* | --- |
* | "Weekly" |
*
* @param {Val_WeeklyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_weekly = /** @type {((inputs?: Val_WeeklyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_WeeklyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_weekly(inputs)
	if (locale === "es") return es_val_weekly(inputs)
	if (locale === "fr") return fr_val_weekly(inputs)
	if (locale === "de") return de_val_weekly(inputs)
	if (locale === "ja") return ja_val_weekly(inputs)
	if (locale === "zh") return zh_val_weekly(inputs)
	if (locale === "ar") return ar_val_weekly(inputs)
	if (locale === "id") return id_val_weekly(inputs)
	if (locale === "it") return it_val_weekly(inputs)
	if (locale === "ru") return ru_val_weekly(inputs)
	if (locale === "pt") return pt_val_weekly(inputs)
	return ko_val_weekly(inputs)
});